const Footer = () => {
  return (
    <footer className="mt-16 mx-4 sm:mx-0 mb-6 px-8 py-6 text-center text-gray-300 backdrop-blur-xl bg-white/5 border border-white/10 rounded-2xl shadow-lg hover:shadow-purple-500/20 transition-all duration-300">
      <p className="text-sm font-medium">
        Developed with ❤️ by Yug
      </p>
    </footer>
  );
};

export default Footer;
